interface B8ildLogoLoaderProps {
  message?: string;
}

export const B8ildLogoLoader = ({ message }: B8ildLogoLoaderProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 gap-6">
      {/* Logo animé avec pulse + couleur qui voyage */}
      <div
        className="flex items-baseline select-none"
        style={{ animation: "b8ild-pulse 3s ease-in-out infinite" }}
        aria-hidden="true"
      >
        <span className="text-5xl font-bold" style={{ animation: "b8ild-B 3s ease-in-out infinite" }}>B</span>
        <span className="text-5xl font-bold" style={{ animation: "b8ild-8 3s ease-in-out infinite" }}>8</span>
        <span className="text-5xl font-bold" style={{ animation: "b8ild-i 3s ease-in-out infinite" }}>i</span>
        <span className="text-5xl font-bold" style={{ animation: "b8ild-l 3s ease-in-out infinite" }}>l</span>
        <span className="text-5xl font-bold" style={{ animation: "b8ild-d 3s ease-in-out infinite" }}>d</span>
      </div>

      {/* Message avec points animés */}
      {message && (
        <p className="text-muted-foreground text-sm flex items-center gap-1">
          {message}
          <span className="inline-flex gap-0.5">
            <span className="h-1 w-1 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: "0ms" }} />
            <span className="h-1 w-1 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: "150ms" }} />
            <span className="h-1 w-1 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: "300ms" }} />
          </span>
        </p>
      )}

      {/* Keyframes : pulse global + couleur ambrée qui voyage lettre par lettre */}
      <style>{`
        @keyframes b8ild-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes b8ild-B {
          0%, 7%    { color: white; }
          10%, 18%  { color: #f59e0b; }
          21%, 100% { color: white; }
        }
        @keyframes b8ild-8 {
          0%, 7%    { color: #f59e0b; }
          10%, 18%  { color: white; }
          21%, 32%  { color: #f59e0b; }
          35%, 58%  { color: white; }
          61%, 100% { color: #f59e0b; }
        }
        @keyframes b8ild-i {
          0%, 32%   { color: white; }
          35%, 42%  { color: #f59e0b; }
          45%, 100% { color: white; }
        }
        @keyframes b8ild-l {
          0%, 42%   { color: white; }
          45%, 52%  { color: #f59e0b; }
          55%, 100% { color: white; }
        }
        @keyframes b8ild-d {
          0%, 52%   { color: white; }
          55%, 62%  { color: #f59e0b; }
          65%, 100% { color: white; }
        }
      `}</style>
    </div>
  );
};
